import React from "react";
import PrintInvoice from ".";
import Style from "./PrintInvoice.module.scss";

const ViewPickListDetails = React.forwardRef((props, ref) => {
  return (
    
    <div className={`${Style.pdf_container}`} >
      <div ref={ref} style={{ maxWidth: 595, width: "100%", fontSize: 8, margin: "0px auto", padding: 40 }} id="element-to-print">
        {props?.invoiceData && props?.invoiceData?.result.map((item, index) => (
          <PrintInvoice
            key={index}
            index={index}
            item={item}
            // Add other props as needed
          />
        ))}
      </div>
      </div>
    
    // <></>
  
  );
});

export default ViewPickListDetails;
